<template>
    <button
        :class="['form-button', { 'btn-primary': primary, 'btn-secondary': secondary ,'btn-danger': danger}]"
        @click="onClick"
        :style="buttonStyle"
        :disabled="disabled"
    >
        <span style="white-space: nowrap">  {{ text }}</span>
    </button>
</template>

<script>
export default {
    props: {
        text: {
            type: String,
            required: true,
        },
        primary: {
            type: Boolean,
            default: false,
        },
        secondary: {
            type: Boolean,
            default: false,
        },
        danger:{
            type: Boolean,
            default: false,
        },
        width: {
            type: String,
            default: null,
        },
        marginBottom: {
            type: String,
            default: "0",
        },
        disabled:{
            type: Boolean,
            default: false,
        }
    },
    computed: {
        buttonStyle() {
            return {
                ...(this.width && { width: this.width }),
                marginBottom: this.marginBottom,
            };
        },
    },
    methods: {
        onClick() {
            this.$emit("click");
        },
    },
};
</script>

<style scoped>
.form-button {
    padding: 0rem 1rem;
    height: 45px;
    background: rgba(0, 255, 150, 0.1);
    border: 1px solid rgba(0, 255, 150, 0.3);
    border-radius: 6px;
    color: #00ff96;
    font-size: 0.85rem;
    cursor: pointer;
    transition: all 0.3s ease;
}

.btn-primary {
    background: linear-gradient(135deg, #00ff96, #00d4ff);
    color: #0a0e27;
    font-weight: 600;
}

.btn-primary:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 30px rgba(0, 255, 150, 0.3);
}

.btn-secondary {
    background: rgba(20, 35, 70, 0.5);
    border: 1px solid rgba(0, 255, 150, 0.3);
    color: #00ff96;
}

.btn-secondary:hover {
    background: rgba(0, 255, 150, 0.1);
    border-color: #00ff96;
}

.btn-danger {
    background: linear-gradient(135deg, #c70000, #e49c00);
    color: #ffffff;
}

.btn-danger:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 30px rgba(255, 136, 0, 0.3);
}

.form-button:disabled {
    cursor: not-allowed;
    background: rgb(17 29 56);
    border-color: rgb(174 174 174 / 40%);
    color: rgb(135 135 135 / 80%);
}

</style>